import { IApplicationState } from '../../../types/redux';

/**
 * Возвращает тип текущей страницы
 */
export const selectPageType = ({ settings: { pageType } }: IApplicationState) => pageType;
